"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateIdentityProofKycDocumentOptions = void 0;
class CreateIdentityProofKycDocumentOptions {
    mangopayId;
    userId;
}
exports.CreateIdentityProofKycDocumentOptions = CreateIdentityProofKycDocumentOptions;
//# sourceMappingURL=CreateIdentityProofKycDocumentOptions.js.map